/**
 * @see https://www.w3schools.com/howto/howto_js_scroll_to_top.asp
 */ function scrollTo(top) {
    if (top === void 0) top = 0;
    document.body.scrollTop = top; // For Safari
    document.documentElement.scrollTop = top; // For Chrome, Firefox, IE and Opera
}
export { scrollTo };
